import React, { Component } from 'react';
import HomePageHeader from './HomePageHeader/HomePageHeader';
import HomePageBody from './HomePageBody/HomePageBody';
import HomePageFooter from './HomePageFooter/HomePageFooter';
import {connect} from 'react-redux';
import { sendMessage } from '../../store/actions/ToolkitActions';
import { ToastContainer, toast } from 'react-toastify';

class HomePageContainer extends Component {
  render() {
      return (
          <div>
            <ToastContainer
              position="top-right"
              type="success"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              pauseOnHover
            />
            <HomePageHeader />
            <HomePageBody
              sendMessage={this.props.sendMessage}
              messageSuccess={this.props.messageSuccess}
            />
            <HomePageFooter />
          </div>
    )
  }
}

const mapStateToProps = (store, verify) => {
  return {
    messageSuccess: store.ToolkitReducer.messageSuccess,
  }
};

const mapDispatchToProps = (dispatch) => ({
  sendMessage: (data) => dispatch(sendMessage(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);



// WEBPACK FOOTER //
// ./src/containers/Home/HomePage.js